import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(value: number, format?: 'number' | 'currency' | 'percent'): string {
  if (format === 'currency') {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }
  if (format === 'percent') {
    return new Intl.NumberFormat('ru-RU', {
      style: 'percent',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value / 100);
  }
  return new Intl.NumberFormat('ru-RU').format(value);
}

export function getDeltaPercent(current: number, previous: number): number {
  if (previous === 0) return 0;
  return ((current - previous) / previous) * 100;
}

/**
 * Классы для табов — единый глобальный стиль с подсветкой активной вкладки.
 * Использует theme-aware классы (text-primary, border-primary, hover:text-foreground).
 *
 * Пример:
 *   <button className={getTabClass(active === 'tab1')}>Tab 1</button>
 *
 * Параметры:
 *   active — true если вкладка активна
 *   size — 'sm' | 'md' (по умолчанию 'sm')
 */
export function getTabClass(active: boolean, size: 'sm' | 'md' = 'sm'): string {
  const padding = size === 'md' ? 'px-4 py-2.5 text-sm' : 'px-3 py-2 text-xs';
  const base = `${padding} font-medium border-b-2 transition-colors`;
  return active
    ? `${base} text-primary border-primary`
    : `${base} text-muted-foreground border-transparent hover:text-foreground hover:border-muted-foreground/50`;
}
